
import ReactHTMLTableToExcel from "react-html-table-to-excel"

export const SewerageWorkNameExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <tr style={{ border: '1px solid black' }}>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16 }}>
                        {name}
                    </th>
                </tr>

                {/* <tr><td></td></tr> */}

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th>Work Type</th>
                        <th>Work Period</th>
                        <th>Work Name</th>
                        <th>Bench Mark (Days)</th>
                        <th>Penalty Description</th>
                        <th style={{ borderRight: "1px solid black" }}>Penalty Amount(Rs)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => (
                            <tr style={{ width: '100%', border: "1px solid black" }}>
                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                <td style={{ textAlign: "center" }}>{item.workType ? item.workType : '-'}</td>
                                <td style={{ textAlign: "center" }}>{item.m_sW_WorkPeriod ? item.m_sW_WorkPeriod : '-'}</td>
                                <td style={{ textAlign: "center" }}>{item.workName ? item.workName : '-'}</td>
                                <td style={{ textAlign: "center" }}>{item.benchMarks ? item.benchMarks : '0'}</td>
                                <td style={{ textAlign: "center" }}>{item.penaltyDescription ? item.penaltyDescription : '-'}</td>
                                <td style={{ textAlign: "center" }}>{item.penaltyAmount ? item.penaltyAmount.toFixed(2) : '0.00'}</td>
                            </tr>
                        )) :
                            <td colSpan={15}>No data found</td>
                    }

                </tbody>
            </table>
        </div>
    )
}